import { rootApi } from '../rootApi';

export const userAccountApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getUserAccounts: builder.query({
            query: (params) => ({
                url: 'v1/account/getlist',
                method: 'POST',
                body: {
                    activeOnly: params.activeOnly !== undefined ? params.activeOnly : 1,
                    pageNumber: params.pageNumber || 0,
                    pageSize: params.pageSize || 0,
                    languageId: params.languageId || 1,
                    firstName: params.firstName || '',
                    lastName: params.lastName || '',
                    email: params.email || '',
                    dealerName: params.dealerName || '',
                    dealerAddressId: params.dealerAddressId,
                    country: params.country,
                    sortBy: params.sortBy ?? null,
                    sortDir: params.sortDir ?? null
                }
            }),
            providesTags: ['UserAccounts']
        }),
        getUserById: builder.query({
            query: ({ id, languageId }) => ({
                url: `v1/account/getbyid`,
                method: 'GET',
                params: { id, languageId }
            }),
            providesTags: ['UserAccount']
        }),
        createUserAccount: builder.mutation({
            query: (data) => ({
                url: 'v1/account/save',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['UserAccounts']
        }),
        updateUserAccount: builder.mutation({
            query: (data) => ({
                url: 'v1/account/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['UserAccounts', 'UserAccount']
        }),
        deleteUserAccount: builder.mutation({
            query: (id) => ({
                url: 'v1/account/delete',
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: ['UserAccounts']
        })
    })
});

export const { useGetUserAccountsQuery, useGetUserByIdQuery, useCreateUserAccountMutation, useUpdateUserAccountMutation, useDeleteUserAccountMutation } = userAccountApi;
